import { IEmployeeSubscription } from './employees.service';
import { BaseEntity } from '../base/base.entity';
import { AppService } from '../main/app.service';
import { BaseService, IGetListParams } from '../base/base.service';
import { IDeclaration } from "./index";

export class IShift extends BaseEntity {
    subscriptions: any;
    name: string;
    teamId: string;
    teamName: string;
    teamLocationId: string;
    teamLocationAccountId: string;
    teamLocationSalaryScaleGroupId?: string;
    teamLocationSalaryScaleGroupName?: string;
    employeeId: string;
    employeeDisplayName: string;
    start: any;
    end: any;
    startDate?: any;
    endDate?: any;
    startTime?: any;
    endTime?: any;
    comment: string;
    functionId: string;
    code: number;
    declarations: IDeclaration[];
    subscribed: boolean = false;
    isInThePast: boolean = false;
    accountId: string;
    locationId: string;
    status: number;
    statusColor: string;
    teamLocationName: string;
    plannedHours: number;
    declaredHours: number;
    hoursDifference: number;
    subscriptionsCount?: number;
    mySubscription?: IEmployeeSubscription;
    distance: number;
}
export interface IGetShiftListParams extends IGetListParams {
    from: string,
    till: string,
    includeSubscriptions: boolean,
    includeDistance?: boolean,
    status?: string
    createdBy?: string;
    createdSince?: string;
    updatedBy?: string;
    updatedSince?: string;
}

export class IBulkactionData {
    ids: string[];
    shiftBulkAction: "None" | "ChangeStatus" | "Delete" | "SetEmployee" | "SendEmail";
    statusId?: number;
    employeeId?: string;
    shiftEmail?: "None" | "Customer" | "EmployeeSubscribe" | "EmployeeConfirm";
}

export class ShiftService extends BaseService<IShift> {
 
    constructor(protected Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'shift');
    }

    public getFilter = (params: IGetShiftListParams): ng.IPromise<IShift[]> => {
        params.limit = params.limit ?  params.limit : 5000;
        return this.Restangular.all(this.itemName).customGET('', params).then((response: Restangular.ICollection) => {
            this.list = response.plain().value;
            return this.listLoaded(this.list);
        });
    }

    public getLightByDate = (params: IGetShiftListParams): ng.IPromise<IShift[]> => {
        params.limit = params.limit ?  params.limit : 5000;
        return this.Restangular.all(this.itemName + '/getLightByDate').customGET('', params).then((response: Restangular.ICollection) => {
            this.list = response.plain().value;
            return this.listLoaded(this.list);
        });
    }

    public getByEmployee = (start, end, employeeId): ng.IPromise<IShift[]> => {
        var params = {'start': start, 'end': end}
        return this.Restangular.all(this.itemName + '/employee').customGET(employeeId, params).then((response: Restangular.ICollection) => {
            this.list = response.plain();
            return this.listLoaded(this.list);
        });
    }

    public getByCurrentEmployee = (start, end): ng.IPromise<IShift[]> => {
        var params = {'start': start, 'end': end}
        return this.Restangular.all(this.itemName + '/employee').customGET('', params).then((response: Restangular.ICollection) => {
            this.list = response.plain();
            return this.listLoaded(this.list);
        });
    }

    public bulkAction = (data:IBulkactionData) => {
        return this.Restangular.all(this.itemName + '/bulk').post(data).then((item: Restangular.IElement) => {
            this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
            return item.plain();
        })
        .catch((error) => {
            this.AppService.NotifyService.error('Foutmelding', error.data);
            return error;
        });
    } 
}




// WEBPACK FOOTER //
// ./src/app/services/shifts.service.ts